'use strict';
var React = require('react');

var LazyLoad = React.createClass({
  propTypes: {
    disabled: React.PropTypes.bool,
    onLoad: React.PropTypes.func,
    order: React.PropTypes.string
  },
  getInitialState: function () {
    return {
      load: !!this.props.disabled,
      loading: false
    };
  },
  componentDidMount: function () {
    var self = this;
    if (!this.props.load) {
      window.requestAnimationFrame(function () {
        self.setState({
          load: true,
          loading: true
        });
      });
    }
  },
  componentWillUnmount: function () {
    clearTimeout(this.timer);
  },
  componentDidUpdate: function () {
    if (this.state.loading && this.state.load) {
      this.props.onLoad && this.props.onLoad();
      this.setState({
        loading: false
      });
    }
  },
  render: function () {
    var style = {
      zIndex: this.props.order
    };
    return (<div style={style}>
      {this.state.load && this.props.children}
    </div>);
  }
});

module.exports = LazyLoad;



// WEBPACK FOOTER //
// ./src/views/common/LazyLoad.jsx